// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleSwitch_wrapper__C01Uv","switch_box":"ToggleSwitch_switch_box__85zjh","tooltip":"ToggleSwitch_tooltip__a4r6a","switch":"ToggleSwitch_switch__3qVrH"};